function Icon8() {
    return (

        <svg id="icon8" width="172" height="172" viewBox="0 0 172 172" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="30" width="142" height="18" fill="#FFFFFF"/>
            <rect x="154" y="142" width="142" height="18" transform="rotate(-90 154 142)" fill="#FFFFFF"/>
            <rect x="0.536728" y="158.873" width="211.952" height="18" transform="rotate(-45 0.536728 158.873)" fill="#FFFFFF"/>
        </svg>

    )
}

export default Icon8